<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">

        <div class="text-center">
            <b-form-group>
                <b-form-radio-group
                        v-model="showDispenses"
                        name="radios-btn-default" :buttons="true">
                    <b-form-radio :value="false" @change="onMarcheSearch()">
                        Historique des saisies
                    </b-form-radio>
                    <b-form-radio :value="true" v-if="marcheId">
                        Historique des dispenses
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
        </div>

        <div v-if="!showDispenses">
            <h2>Consulter ou modifier les bilans trimestriels des recrutements soumis</h2>

            <b-col cols="10">
                <b-row>
                    <b-col cols="3">
                        <b-form-group id="input-group-marches"
                                      label="Marché" label-for="input-marches"
                                      v-if="isAdmin">
                            <AutocompleteCustom
                                    id="input-marches"
                                    :items="marcheIdsItems"
                                    v-model="marcheId"
                                    @search="onMarcheSearch"
                                    :placeholder=libelles.selectionnerMarche>
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                    <b-col cols="2">
                        <b-form-group id="input-group-lignes"
                                      label="Ligne" label-for="input-lignes"
                                      v-if="isAdmin">
                            <b-form-select
                                    id="input-lignes"
                                    v-model="ligneId"
                                    :options="lignes"
                                    required>
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner une ligne
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group id="input-group-trimestre"
                                      label="Trimestre de la saisie" label-for="input-trimestre"
                                      v-if="isAdmin">
                            <b-form-select
                                    id="input-trimestres"
                                    v-model="trimestreId"
                                    :options="trimestres"
                                    @change="search"
                                    required>
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner un trimestre
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group id="input-group-territoire"
                                      label="Territoire" label-for="input-territoire"
                                      v-if="isAdmin">
                            <b-form-select
                                    id="input-territoire"
                                    v-model="territoireId"
                                    :options="territoires"
                                    @change="search"
                                    required>
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner un territoire
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="1">
                        <b-button type="button" variant="success" @click="exporter">Exporter
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <b-form-group id="input-group-statuts"
                                      label="Statut" label-for="input-statuts">
                            <b-form-select
                                    id="input-statuts"
                                    v-model="statuts"
                                    @change="search">
                                <b-form-select-option
                                        :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION']">
                                    Valides et en attente
                                </b-form-select-option>
                                <b-form-select-option :value="['BROUILLON']">
                                    Brouillons
                                </b-form-select-option>
                                <b-form-select-option
                                        :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION', 'BROUILLON', 'REFUSE']">
                                    Tous
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

            </b-col>

            <div v-if="synthesesResult">
                <div class="overflow-auto">
                    <b-row class="align-content-center">
                        <b-col cols="2">
                            <b-form-select
                                    v-model="pageSize"
                                    :options="pageSizes"
                                    @change="search()"
                            ></b-form-select>
                        </b-col>
                        <b-col cols="4" offset="1">
                            <b-pagination
                                    v-model="pageIndex"
                                    :total-rows="synthesesResult.totalElements"
                                    :per-page="pageSize"
                                    :limit="10"
                                    align="center"
                                    @input="search()"
                            ></b-pagination>
                        </b-col>
                    </b-row>

                    <b-table striped hover
                             :per-page="pageSize"
                             :no-local-sorting="true"
                             @sort-changed="sort"
                             :items="synthesesTable" :fields="fields">
                        <template v-slot:cell(num)="row">
                            <div>
                                {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                            </div>
                        </template>
                        <template v-slot:cell(edit)="row">
                            <b-button size="sm" @click="consulterSynthese(row.item.id)"
                                      v-if="(row.item.statut !== 'VALIDE' && row.item.statut !== 'BROUILLON') || isRead">
                                <Icon icon="book-open" size="1x"></Icon>
                            </b-button>
                            <b-button size="sm" @click="consulterSynthese(row.item.id)"
                                      v-if="(row.item.statut === 'VALIDE' || row.item.statut === 'BROUILLON') && (!row.item.jourSoumissionPassed || isAdminGpec) && !isRead">
                                <Icon icon="edit" size="1x"></Icon>
                            </b-button>
                            <b-button size="sm"
                                      v-if="(row.item.statut === 'VALIDE' || row.item.statut === 'BROUILLON') && row.item.jourSoumissionPassed && !isAdminGpec && !isRead"
                                      v-b-modal="'modal-edit' + row.item.id">
                                <Icon icon="edit" size="1x"></Icon>
                            </b-button>
                            <b-modal
                                    :id="'modal-edit' + row.item.id"
                                    title="Modification de bilan trimestriel des recrutements"
                                    ok-title="Confirmer"
                                    cancel-title="Annuler"
                                    @ok="consulterSynthese(row.item.id)">
                                <p>{{libelles.messageHorsPeriodeSoumission}}</p>
                            </b-modal>
                        </template>
                        <template v-slot:cell(export)="row">
                            <b-button size="sm" @click="exportUnitaire(row.item.id)">
                                <Icon icon="file-export" size="1x"></Icon>
                            </b-button>
                        </template>
                        <template v-slot:cell(delete)="row">
                            <b-button size="sm" v-b-modal="'modal-delete' + row.item.id"
                                      v-if="row.item.statut !== 'ATTENTE_SUPPRESSION' && row.item.statut !== 'SUPPRIMEE' && row.item.statut !== 'ARCHIVEE'">
                                <Icon icon="trash" size="1x"></Icon>
                            </b-button>
                            <b-modal
                                    :id="'modal-delete' + row.item.id"
                                    title="Suppression de bilan trimestriel des recrutements"
                                    ok-title="Confirmer"
                                    cancel-title="Annuler"
                                    @ok="supprimerSynthese(row.item)">
                                <p>Confirmez-vous la suppression de ce bilan trimestriel des recrutements ?</p>
                                <p v-if="row.item.statut === 'VALIDE'">
                                    La suppression de ce bilan trimestriel des recrutements entrainera la suppression
                                    des
                                    modifications en attente associées.
                                </p>
                                <p v-if="row.item.jourSoumissionPassed && !isAdminGpec && row.item.statut === 'VALIDE'">
                                    {{libelles.messageHorsPeriodeSoumission}}
                                </p>
                            </b-modal>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>

        <div v-if="showDispenses">
            <UtilisateurDispenses :onglet="'GPEC_REALISE'" :marche-id="marcheId"></UtilisateurDispenses>
        </div>

    </div>
</template>

<script>

  import GpecSyntheseRealiseStore from "../../../stores/GpecSyntheseRealiseStore";
  import AlertStore from "../../../stores/AlertStore";
  import MarcheStore from "../../../stores/MarcheStore";
  import LigneStore from "../../../stores/LigneStore";
  import SessionStore from '@/stores/SessionStore'
  import hasPermission from "../../../filters/hasPermission";
  import {EventBus} from '@/event-bus'
  import {StatutEnum} from "../../../constants/enums";
  import GpecSyntheseRealiseDto from "../../../dtos/GpecSyntheseRealiseDto";
  import FileUtil from "../../../utils/fileUtil";
  import {libelles} from '../../../constants/libelles';
  import TrimestreStore from "../../../stores/TrimestreStore";
  import TerritoireStore from "../../../stores/TerritoireStore";
  import AutocompleteCustom from "../../../components/AutocompleteCustom";
  import UtilisateurDispenses from "../../reporting/UtilisateurDispenses";

  export default {
    components: {
      AutocompleteCustom, UtilisateurDispenses
    },
    data() {
      return {
        sessionStoreState: SessionStore.state,
        marcheId: null,
        ligneId: null,
        trimestreId: null,
        territoireId: null,
        marches: [],
        lignes: [],
        trimestres: [],
        territoires: [],
        statuts: ['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION'],
        synthesesResult: null,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        libelles: libelles,
        marcheIdsItems: [],
        showDispenses: false
      }
    },
    computed: {
      isAdminGpec() {
        return hasPermission(["ADMINISTRATEUR", "CORRESPONDANT_GPEC_ADMINISTRATEUR"]);
      },
      isAdmin() {
        return this.isAdminGpec && !this.sessionStoreState.marches.length;
      },
      isRead() {
        return hasPermission(['CORRESPONDANT_GPEC_LECTURE'])
      },
      fields() {
        const fields = [
          {label: '', key: 'num', sortable: false},
          {label: 'Trimestre de la saisie', key: 'trimestre', sortable: true},
          {label: 'Trimestre saisi', key: 'trimestrePrecedent', sortable: false},
          {label: 'Date de dernière modification', key: 'modifiedDate', sortable: true},
          {label: 'Statut', key: 'statutLabel', sortable: false},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Exporter', key: 'export', sortable: false},
          {label: 'Supprimer', key: 'delete', sortable: false}
        ];
        if (this.isAdmin) {
          fields.splice(1, 0, {label: 'Marché', key: 'marche', sortable: true})
        }
        if (this.isRead) {
          fields.splice(fields.length - 1, 1)
        }
        return fields;
      },
      synthesesTable: function () {
        return this.synthesesResult.content.map(synthese => {
          return {
            id: synthese.id,
            trimestre: synthese.trimestre.libelle,
            marche: `${synthese.marche.reference} (${synthese.marche.libelleCourt})`,
            statut: synthese.statut,
            statutLabel: StatutEnum[synthese.statut],
            jourSoumissionPassed: synthese.jourSoumissionPassed,
            modifiedDate: synthese.modifiedDate ? new Date(synthese.modifiedDate).toLocaleDateString() : null,
            trimestrePrecedent: synthese.trimestrePrecedent.libelle

          }
        });
      }
    },
    watch: {
      marcheId(newMarcheId) {
        this.onMarcheSearch(newMarcheId, true);
        this.search();
      },
      ligneId() {
        this.onMarcheSearch();
        this.search();
      },
    },
    mounted() {
      this.initPagination();
      if (this.isAdmin) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
          });
          this.marcheIdsItems = this.marches;
        });
        LigneStore.getAll().then(
            response => this.lignes = response.map(value => {
              return {text: value.libelleLong, value: value.id};
            })
        );
        TrimestreStore.getAll().then(trimestres => {
          this.trimestres = trimestres.map(trimestre => {
            return {text: `${trimestre.libelle}`, value: trimestre.id};
          });
        });
        TerritoireStore.getAll().then(
            response => this.territoires = response.map(territoire => {
              return {text: territoire.libelle, value: territoire.id};
            })
        );
        this.search();
      } else {
        this.marcheId = this.sessionStoreState.marche.id;
        EventBus.$on('NavBar-marcheChange', () => {
          this.marcheId = this.sessionStoreState.marche.id;
          this.search();
        });
      }
    },
    beforeDestroy() {
      if (!this.isAdmin) {
        EventBus.$off('NavBar-marcheChange');
      }
    },
    methods: {
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        const sortBy = !this.isAdmin ? 'trimestre' : 'marche';
        this.sortOptions = [{sortBy: sortBy, sortDirection: 'asc'}];
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      consulterSynthese(id) {
        this.$router.push("/gpec-bilan-trimestriel/" + id);
      },
      supprimerSynthese(synthese) {
        GpecSyntheseRealiseStore.delete(synthese).then(() => {
          this.search();
        });
      },
      search() {
        const synthese = this.getSearchSynthese();
        GpecSyntheseRealiseStore.search(synthese, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.synthesesResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      exporter() {
        const synthese = this.getSearchSynthese();
        GpecSyntheseRealiseStore.export(synthese).then(
            result => {
              FileUtil.downloadFile(result.data, 'application/zip');
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      exportUnitaire(syntheseId) {
        GpecSyntheseRealiseStore.exportById(syntheseId).then(
            result => {
              FileUtil.downloadFile(result.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      getSearchSynthese() {
        const synthese = new GpecSyntheseRealiseDto();
        synthese.marche = this.marcheId;
        synthese.ligne = this.ligneId;
        synthese.statut = this.statuts;
        synthese.trimestre = this.trimestreId;
        synthese.territoire = this.territoireId;
        return synthese;
      },
      onMarcheSearch(marche, isId) {
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marches)
      }
    }
  }
</script>

